export default "__VITE_ASSET__D227k8fR__"